import numeral from 'numeral'

export  function getCurrencyFormat (num) {
  return numeral(num / 100).format('$0,000.00')
}

export  function getCurrencyFormatSmall (num) {
  return numeral(num / 100).format('$0,000')
}